import React, {useEffect, useRef, useState} from "react"
import eventBus from "../../utils/EventBus"
import styles from './Backdrop.module.scss'

export default function Backdrop() {
    const [visible, setVisible] = useState(false)
    const [data, setData] = useState(null);
    // Tracks whether the mousedown that started this click landed on the backdrop
    // itself, so a text-selection drag that starts inside the modal and ends outside
    // it (a common accident) doesn't get treated as a click on the backdrop - click
    // events fire on the nearest common ancestor of the mousedown/mouseup targets,
    // which is the backdrop in that case, bypassing the modal content's stopPropagation.
    const mouseDownOnBackdrop = useRef(false);

    useEffect(() => {
        const showModal = (incoming) => {
            console.log("Show modal")
            setVisible(Boolean(incoming))
            setData(incoming ?? null)
        }
        eventBus.subscribe('modal', showModal)
        return () => eventBus.unsubscribe('modal', showModal)
    }, []);

    function handleClose() {
        setVisible(false)
        setData(null)
    }

    function handleMouseDown(e) {
        mouseDownOnBackdrop.current = e.target === e.currentTarget;
    }

    function handleClick(e) {
        if (mouseDownOnBackdrop.current && e.target === e.currentTarget) {
            handleClose();
        }
        mouseDownOnBackdrop.current = false;
    }

    return (
        <div hidden={!visible} onMouseDown={handleMouseDown} onClick={handleClick} className={styles.backdrop}>
            <div className={styles.children}>
                {data?.content ?? null}</div>
        </div>
    )
}